export default __webpack_public_path__ + "static/media/diagonal_line_green.e6ab589b.svg";